import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import backArrowIcon from '../../assets/img/back-arrow.png';
import { formatDateToYYYYMMDD } from '../../utils/format-time';
import exportIcon from '../../assets/icon/icon-export-excel.svg';
import { API_URL } from '../../utils/constant';
import { formatReceiptCurrency } from '../../utils/format-number';
import axios from 'axios';
import * as XLSX from 'xlsx';
import { Pagination } from '../../components/Pagination';

const LIMIT = 20;

const StockPurchaseReport = () => {
    const backPath = '/report/list';

    const today = new Date();
    const oneMonthAgo = new Date(today);
    oneMonthAgo.setMonth(today.getMonth() - 1);

    const [startDate, setStartDate] = useState(formatDateToYYYYMMDD(oneMonthAgo));
    const [endDate, setEndDate] = useState(formatDateToYYYYMMDD(today));
    const [data, setData] = useState([]);
    const [page, setPage] = useState(1);
    const visibleData = data.slice((page - 1) * LIMIT, page * LIMIT);

    const fetchStockPurchaseReport = () => {
        let url = API_URL + `/report/stock_purchase?fromDate=${startDate}&toDate=${endDate}`;
        return axios
            .get(`${url}`, {
                withCredentials: true,
            })
            .then((response) => {
                setData(response.data.data)
            })
            .catch((e) => {
                console.log(e.response);
            });
    };

    useEffect(() => {
        setPage(1);
    }, [data]);


    const handleExportClick = (fileName) => {
        const table = document.querySelector("#xlsx-export-all").cloneNode(true);
        const workbook = XLSX.utils.table_to_book(table, { display: false });
        XLSX.writeFile(workbook, fileName)
    };

    return (
        <div className='sub-page-layout-1'>
            <div className='container' style={{ height: 'auto' }}>
                <div className="report-page-header text-3xl">
                    <div className="report-page-heading">
                        <Link className='back-to-page' to={backPath}>
                            <img src={backArrowIcon} />
                            Back
                        </Link>
                        <h1 className='sub-page-title'>Purchase Report</h1>
                    </div>

                    <div className="report-toolbar">
                        <input
                            required
                            name="start_date"
                            value={startDate}
                            onChange={e => setStartDate(e.target.value)}
                            className="x-input report-date-input"
                            type="date"
                        />
                        <input
                            required
                            name="end_date"
                            value={endDate}
                            onChange={e => setEndDate(e.target.value)}
                            className="x-input report-date-input"
                            type="date"
                        />
                        <button className="gold-btn report-run-button" onClick={fetchStockPurchaseReport}>
                            Run Report
                        </button>
                        <button
                            className="gold-btn report-export-button"
                            onClick={() => {
                                handleExportClick(`Stock_Purchase_Report_from_${startDate}_to_${endDate}.xlsx`)
                            }}
                        >
                            <img src={exportIcon} alt="export excel icon" />
                            <span>Export Excel</span>
                        </button>
                    </div>
                </div>
                <div className="table-container">
                    <table className="x-table" id="xlsx-export">
                        <thead>
                        <tr style={{ "position": "absolute", "width": "0", "height": "0", "padding": "0", "border": "0" }}>
                                <th className="hidden" colSpan={1}></th>
                                <th className="hidden">From</th>
                                <th className="hidden">{startDate}</th>
                                <th className="hidden">To</th>
                                <th className="hidden">{endDate}</th>
                            </tr>
                            <tr style={{ "position": "absolute", "width": "0", "height": "0", "padding": "0", "border": "0" }}>
                                <th className="hidden" colSpan={5}></th>
                            </tr>
                            <tr>
                                <th>Date</th>
                                <th>Purchase Order ID</th>
                                <th>Supplier Name</th>
                                <th>Currency Type</th>
                                <th className="report-amount">Total Amount</th>
                            </tr>

                        </thead>
                        <tbody>
                            {visibleData?.map((item, i) => {
                                return (
                                    <tr key={i}>
                                        <td>{item["date"]}</td>
                                        <td>{item["purchase_order_id"]}</td>
                                        <td>{item["supplier_name"]}</td>
                                        <td>{item["currency_type"]}</td>
                                    <td className="report-amount">{formatReceiptCurrency(item["total"], item["currency_type"])}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
                <div style={{ display: 'none' }}>
                    <table id="xlsx-export-all">
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Purchase Order ID</th>
                                <th>Supplier Name</th>
                                <th>Currency Type</th>
                                <th className="report-amount">Total Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data?.map((item, i) => (
                                <tr key={`export-${i}`}>
                                    <td>{item["date"]}</td>
                                    <td>{item["purchase_order_id"]}</td>
                                    <td>{item["supplier_name"]}</td>
                                    <td>{item["currency_type"]}</td>
                                        <td className="report-amount">{formatReceiptCurrency(item["total"], item["currency_type"])}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <div className="w-full flex justify-end mt-4">
                    <Pagination page={page} totalCount={data.length} limit={LIMIT} onChange={setPage} />
                </div>
            </div>
        </div>
    )
}

export default StockPurchaseReport;
